export default "__VITE_ASSET__CswzwPKc__"